<template>
  <CRow>
    <CCol col="12">
      <CCard>
        <CCardHeader>
          <CRow>
            <CCol sm="7">
              <h4 id="traffic" class="card-title mb-0">Corporate List</h4>
            </CCol>
          </CRow>
        </CCardHeader>
        <CCardBody>
          <CRow class="mb-1">
            <CCol col="2">
              <CButton
                color="primary"
                class="float-left mb-2"
                @click="corporateActionCreate"
              >
                Create
              </CButton>
            </CCol>

            <CCol class="d-flex justify-content-end" col="3">
              <div>
                <div>Bahasa: </div>
                <div class="mt-2">
                  <CInputRadio
                    @input="selectLanguage('indonesia')"
                    value="indonesia"
                    :inline="true"
                    name="event-and-tips-language"
                    id="language-id" 
                    label="Indonesia" 
                    :checked="selectedLanguage === 'indonesia'"
                  />
                  <CInputRadio
                    @input="selectLanguage('english')"
                    value="english"
                    :inline="true"
                    name="event-and-tips-language"
                    id="language-my"
                    label="English" 
                    :checked="selectedLanguage === 'english'"
                  />
                </div>
              </div>
            </CCol>
            <CCol col="2">
              <div class="option-article">
                <CSelect
                  class="w-20"
                  label="Article Info"
                  :options="optionsArticleInfo"
                  required
                  v-model="request.article_info"
                  @change="handleArticleInfo"
                />
              </div>
            </CCol>
            <CCol col="2">
              <div class="option-status">
                <CSelect
                  label="Status"
                  :options="optionsStatus"
                  required
                  v-model="request.s"
                  @change="handleStatus"
                />
              </div>
            </CCol>
            <!-- Search -->
            <CCol class="float-right" col="3">
              <div class="search-list">
                <CInput
                  label="Cari"
                  class="float-left ml-2 mr-3"
                  placeholder="Search By Coporate Action Title"
                  v-model="request.q"
                  @input="onSearch()"
                >
                  <template #prepend-content>
                    <CIcon name="cil-magnifying-glass" />
                  </template>
                </CInput>
              </div>
            </CCol>
          </CRow>
          <CDataTable
              hover
              striped
              :items="items"
              :fields="fields"
              :items-per-page="100"
              clickable-rows
              :active-page="1"
              :pagination="false"
              @page-change="pageChange"
          >
            <template #corporate_action_ids="data">
              <td>
                <div class="button-table" v-if="!isRestrictedCorporate">
                  <CButton
                      color="primary"
                      class="mb-0 mr-0"
                      @click="rowClicked(data.item.corporate_action_id)"
                  >Edit</CButton
                  >
                </div>
              </td>
            </template>
          </CDataTable>
          <div class="pagination-nav">
            <div
                class="pagination-btn-refresh"
                @click="getCorporateList('REFRESH')"
            >
              Refresh
            </div>
            <div
                class="pagination-btn-back"
                @click="getCorporateList('BACK')"
            >
              back
            </div>
            <div class="pagination-page-title">{{ request.page }}</div>
            <div
                class="pagination-btn-next"
                @click="getCorporateList('NEXT')"
            >
              next
            </div>
          </div>
        </CCardBody>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
import jwt from "jsonwebtoken";
import {TimeMapper} from "../../../app/helper/timeMapper";
import CorporateListUseCase from "./app/usecase";

export default {
  name: "corporate",
  data() {
    return {
      items: [],
      fields: [
        { key: "corporate_action_id", label: "ID" },
        { key: "corporate_action_title", label: "Corporate Action Title" },
        { key: "active_date" },
        { key: "corporate_action_author" },
        { key: "corporate_action_type" },
        { key: "article_info" , label: "Article Info"},
        { key: "status" },
        { key: "corporate_action_ids", label: "Action" },
      ],
      token: "Bearer " + localStorage.getItem("token"),
      request: {
        page: 1,
        per_page: 20,
        q: "",
        article_info: "",
        s: "",
      },
      debounce: {
        timeout: 0,
        duration: 500,
      },
      searchTimeout: null,
      optionsArticleInfo: [
        { label: "All", value: "" },
        { label: "MITRA", value: "MITRA" },
        { label: "SELLER", value: "SELLER" }, 
        { label: "BLOG MALAYSIA", value: "BLOG_MALAYSIA" }
      ],
      optionsStatus: [
        { label: 'All', value: '' },
        { label: 'ACTIVE', value: 'ACTIVE' },
        { label: 'INACTIVE', value: 'INACTIVE' },
      ],
      isRestrictedCorporate:
          localStorage.getItem("isRestrictedCorporate") === "true",
      selectedLanguage: "indonesia",
    };
  },
  mounted() {
    this.authentication();
    this.getCorporateList();
  },
  methods: {
    handleArticleInfo(event) {
      this.request.article_info = event.target.value;
      this.onSearch();
    },
    handleStatus(event) {
      this.request.s = event.target.value;
      this.onSearch();
    },
    authentication() {
      const data = jwt.decode(localStorage.getItem("token"));
      if (
          data.account_group === "MARKETING" ||
          data.account_group === "ADMIN" ||
          data.account_group === "ADMINISTRATOR" ||
          data.account_group === "EXTERNAL"
      ) {
        return null;
      } else {
        this.$router.push({ path: `/` });
      }
    },
    onSearch() {
      clearTimeout(this.searchTimeout)
      this.searchTimeout = setTimeout(this.searchCorporateList, this.debounce.duration);
    },
    async searchCorporateList() {
      try {
        await this.getCorporateList()
        this.request.page = 1
      } catch (err) {
        await this.$swal.fire({
          icon: "error",
          text: err
        })
      }
    },
    async getCorporateList(action) {
      try {
        this.validatePagination(action);
        const queries = Object.keys(this.request).map((key) => key + "=" + this.request[key]).join("&");
        const { data, err } = await CorporateListUseCase.getAll(queries);
        if (err || data.length == 0) {
          this.validateNextPagination(action);
          this.err = err;
        } else {
          if (data) {            
            data.forEach((element) => {
              element.active_date = TimeMapper.SetFormatDate(element.active_date, false, ["/", "/", ":"], true, true)
            });
            window.scrollTo(0, 0);
            this.items = data.map((obj) => {
              return {
                ...obj,
                article_info: this.optionsArticleInfo.find(options => options.value === obj.article_info)?.label || obj.article_info
              }
            });
          }
        }
      } catch (err) {
        await this.$swal.fire({
          icon: "error",
          text: err,
        });
      }
    },
    validatePagination(action) {
      if (action === "NEXT") {
        this.request.page = this.request.page + 1;
      } else if (action === "BACK") {
        if (this.request.page > 1) {
          this.request.page = this.request.page - 1;
        }
      } else if (action === "REFRESH") {
        this.request.page = 1;
      } else {
        this.request.page = 1;
      }
    },
    validateNextPagination(action) {
      if (action === "NEXT") {
        this.request.page = this.request.page - 1;
      } else {
        this.items = [];
      }
    },
    rowClicked(item) {
      this.$router.push({ path: `/management/corporate/${item}` });
    },
    pageChange(val) {
      this.$router.push({ query: { page: val } });
    },
    corporateActionCreate() {
      this.$router.push({ path: `/management/corporate/create` });
    },
    selectLanguage(language) {
      this.selectedLanguage = language;
      this.request.language = language;
      this.searchCorporateList();
    },
  },
};
</script>

<style scoped>
@import url("./Corporate.css");
</style>
